export default __webpack_public_path__ + "static/fitness-externo-18b3a4d30e6c1de623ccd749bc650bc0.jpg";